import { render, staticRenderFns } from "./TextBox.vue?vue&type=template&id=231dbe69&scoped=true&"
import script from "./TextBox.vue?vue&type=script&lang=js&"
export * from "./TextBox.vue?vue&type=script&lang=js&"
import style0 from "./TextBox.vue?vue&type=style&index=0&id=231dbe69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231dbe69",
  null
  
)

export default component.exports